import { render } from "./card3.vue?vue&type=template&id=3fa017cc&scoped=true"
import script from "./card3.vue?vue&type=script&lang=js"
export * from "./card3.vue?vue&type=script&lang=js"

import "./card3.vue?vue&type=style&index=0&id=3fa017cc&lang=scss&scoped=true"

import exportComponent from "/Users/baikaifa/Desktop/ubang-deploy-work/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.42_vue@3.5.42_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa017cc"]])

export default __exports__